import type { NFinancialOperations } from '@pages/Finances/FinancialOperations/FinancialOperations.types';

import type { ColumnsType } from 'antd/es/table';

export const FO_NUMBER = 'number';
export const FO_OPERATION = 'operation';
export const FO_RECORD = 'record';
export const FO_SERVICE_OR_PRODUCT = 'serviceOrProduct';
export const FO_SUM = 'sum';
export const FO_DETAILS = 'details';
export const FO_CLIENT = 'client';
export const FO_USER = 'user';

const generateRest = (id: string) => ({
  dataIndex: id,
  key: id,
});

export const COLUMNS: ColumnsType<NFinancialOperations.Columns> = [
  {
    title: '№',
    ...generateRest(FO_NUMBER),
  },
  {
    title: 'Операция',
    ...generateRest(FO_OPERATION),
  },
  {
    title: 'Запись',
    ...generateRest(FO_RECORD),
  },
  {
    title: 'Услуга или товар',
    ...generateRest(FO_SERVICE_OR_PRODUCT),
  },
  {
    title: 'Сумма',
    ...generateRest(FO_SUM),
  },
  {
    title: 'Детали',
    ...generateRest(FO_DETAILS),
  },
  {
    title: 'Клиент',
    ...generateRest(FO_CLIENT),
  },
  {
    title: 'Пользователь',
    ...generateRest(FO_USER),
  },
];
